import React from 'react';

const dividerStyle = {
  borderTop: '1px solid #999999a8',
  margin: '16px auto',
  width: 190,
};

const Divider = () => <div style={dividerStyle}></div>;

export default Divider;
